import { render, staticRenderFns } from "./editCustom.vue?vue&type=template&id=8a0d7962&scoped=true&"
import script from "./editCustom.vue?vue&type=script&lang=js&"
export * from "./editCustom.vue?vue&type=script&lang=js&"
import style0 from "./editCustom.vue?vue&type=style&index=0&id=8a0d7962&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a0d7962",
  null
  
)

export default component.exports